module.exports = __webpack_public_path__ + "img/gc_country_flag_gb.1c9fbf51.svg";